const { get } = require('network/http/api');

export const getConversationHistory = (id) => {
  return get(`/conversation/${id}/information`);
};
